import $ from 'jquery'

export default () => {
    const nodeSelectors = {
        container: '[js-accordions="container"]',
        opener: '[js-accordions="opener"]',
        hiddenContent: '[js-accordions="hidden-content"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initAccordions()
    }

    function initAccordions() {
        
        $(nodeSelectors.opener).on('click', function (e) {
            e.preventDefault();

            $(nodeSelectors.opener).removeClass('active')
            $(nodeSelectors.opener).next().slideUp();

            if(!$(nodeSelectors.opener).parent().hasClass('active') && $(this).parent().find('.accordion-content').is(":hidden")){
                $(this).toggleClass('active').parent().find(nodeSelectors.hiddenContent).slideDown()
            }

            if ($(this).attr('data-map-image')) {
                let currentimage = $(this).attr('data-map-image');
                let $img = $('.map-section .map-section-wrap .map-section-content .middle .map-holder img');
                let $imgSrc = $img.attr("src");

                if (currentimage !== $imgSrc) {
                    // Preload image first
                    let preload = new Image();
                    preload.src = currentimage;

                    preload.onload = function () {
                        $img.fadeOut(300, function () {
                            $img.attr('src', currentimage).fadeIn(300);
                        });
                    };
                }
            }


            // INDUSTRY IMAGE
            if ($(this).attr('data-industry-image')) {
                let currentimage = $(this).attr('data-industry-image');
                let $img = $('.industries-section-content .right .right-content .right-image img');
                let $imgSrc = $img.attr("src");

                if (currentimage !== $imgSrc) {
                    // Preload image first
                    let preload = new Image();
                    preload.src = currentimage;

                    preload.onload = function () {
                        $img.fadeOut(300, function () {
                            $img.attr('src', currentimage).fadeIn(300);
                        });
                    };
                }
            }
        })
    }

    return Object.freeze({
        init,
    })
}